import {forwardRef, useEffect, useImperativeHandle, useRef, useState} from "react";
import {isElectron} from "react-device-detect";
import type { WebviewTag } from "electron"
import styles from "./bilibili/inject/webview.css?raw"
import scripts from "./bilibili/inject/webview.js?raw"
import {getBilibiliVideoInfo} from "./bilibili/ApiBilibiliInfo";
import {
    getSafeInt,
    getUrlQueryParam,
    isBaiduVideoUrl,
    isBilibiliUrl,
    isObject,
    isYoutubeUrl
} from "../../../../../src/utils";
import {getEmbedLink} from "../../element/embeddable";
import {message} from "antd";
import {toValidURL} from "../../data/url";
import Global from "../../../../../src/global";
import dayjs from "dayjs";
import {isWeb} from "../../../../../src/electron_interactive";
import {KEY_TRANSCRIPT_AUTO_SCROLL} from "../../../../../src/Const";

const VideoOtherContent = forwardRef((props:{url:any,pointerEvents:any,iframeLoad?:any,isAutoPlay?:any,startTime?:any,element?:any,seekTime?:any}, ref)=> {
    useImperativeHandle(ref, () => ({
        reloadIframe: reloadIframe,
        onGetCurrentTime: onGetCurrentTime,
        onSetCurrentTime,
        onPlay,
        onGetVideoInfo:onGetVideoInfo,
        onPauseVideo:onPauseVideo,
        onGetVideoTime:onGetVideoTime,
        onGetVideoThumb:onGetVideoThumb,
        onSetTimeUpdateCallback:onSetTimeUpdateCallback,
        onGetUrl:onGetUrl,
        onIsPlay,
    }))
    const iframeBoxRef = useRef<HTMLDivElement>(null)
    // const [sandBox, setSandBox] = useState<HTMLIFrameElement | WebviewTag | null>(
    //     null,
    // )
    const mSeekTime = useRef<any>(0);
    const mBilibiliInfo = useRef<any>(null);

    const mCurrentPlayUrl = useRef(null);
    const sendBox = useRef<HTMLIFrameElement | WebviewTag | null>(null);
    const mTimer = useRef<any>(0);

    useEffect(() => {
        let isAutoPlay = props.isAutoPlay;
        if (props.element){
            if (isObject(props.element.selectedId)){
                isAutoPlay = true;
                //解析时间...
                const arrayValidateTime = props.element.selectedId.selectId.split(',');
                const arrayTimes = arrayValidateTime[0].split(':');
                if (arrayTimes.length == 1){
                    mSeekTime.current = getSafeInt(arrayTimes[0]);
                }else if (arrayTimes.length == 2){
                    mSeekTime.current = 60*getSafeInt(arrayTimes[0]) + getSafeInt(arrayTimes[1]);
                }else if (arrayTimes.length == 3){
                    mSeekTime.current = 3600*getSafeInt(arrayTimes[0]) + 60*getSafeInt(arrayTimes[1]) + getSafeInt(arrayTimes[2]);
                }

            }
            else if (props.element.selectedId) {
                const item = props.element.videoNotes.find(p => p.id == props.element.selectedId);
                if (item){
                    const dayjsObject = dayjs(item.time);
                    const hours = dayjsObject.hour();
                    const minutes = dayjsObject.minute();
                    const seconds = dayjsObject.second();
                    mSeekTime.current = hours * 3600 + minutes * 60 + seconds;
                }
                isAutoPlay = true;
            }
        }
        if (props.seekTime){
            mSeekTime.current = props.seekTime;
            isAutoPlay = true;
        }

        if (props.url && mCurrentPlayUrl.current != props.url){
            generateIframe(mSeekTime.current,isAutoPlay);
            mCurrentPlayUrl.current = props.url;
        }

        return () => {
            // setSandBox(null)
        }
    }, [props.url,props.isAutoPlay])

    const onGetUrl = ()=>{
        return props.url;
    }

    const onIsPlay = async ()=>{
        if (isElectron) {
            try {
                const isPlay = await (sendBox.current as WebviewTag).executeJavaScript(
                    "window.isVideoPlay();",
                )

                return isPlay;
            } catch (error) {
                console.error("Error getting video time:", error)
            }
        } else {
            // For web environment, you might want to implement a different way to get video time
            console.warn("Video time tracking not implemented for web environment")
        }
        return false;
    }

    const onGetCurrentTime = async () => {
        if (isElectron) {
            try {
                const currentTime = await (sendBox.current as WebviewTag).executeJavaScript(
                    "window.getCurrentVideoTime();",
                )

                return currentTime;
            } catch (error) {
                console.error("Error getting video time:", error)
            }
        } else {
            // For web environment, you might want to implement a different way to get video time
            console.warn("Video time tracking not implemented for web environment")
        }
        return 0;
    }

    const onSetCurrentTime = async (time:any)=>{
        if (isElectron) {
            try {
                await (sendBox.current as WebviewTag).executeJavaScript(
                    `window.setCurrentTime(${time});`,
                )
            } catch (error) {
                console.error("Error set video time:", error)
            }
        } else {
            // For web environment, you might want to implement a different way to get video time
            console.warn("Video time tracking not implemented for web environment")
        }
    }

    const onPlay  = ()=>{
        try {
            (sendBox.current as WebviewTag).executeJavaScript(
                `window.onPlay();`,
            )
        } catch (error) {
            console.error("Error set video time:", error)
        }
    }

    /**
     * 设置视频时间更新回调
     * @param callback
     */
    const onSetTimeUpdateCallback = async (nStartTime,nEndTime,isLoop)=>{
        if (isElectron) {
            try {
                await (sendBox.current as WebviewTag).executeJavaScript(
                    `window.setTimeUpdateCallback(${nStartTime},${nEndTime},${isLoop},${(time)=>{console.log('*******'+time)}});`,
                )
            } catch (error) {
                console.error("Error set video timeupdate:", error)
            }
        } else {
            // For web environment, you might want to implement a different way to get video time
            console.warn("Video time tracking not implemented for web environment")
        }
    }


    /**
     * 读取视频信息
     */
    const onGetVideoInfo = ()=>{
        return mBilibiliInfo.current;
    }

    const onGetVideoTime = async ()=>{
        if (isElectron) {
            try {
                const videoTime = await (sendBox.current as WebviewTag).executeJavaScript(
                    "window.getVideoTime();",
                )

                return videoTime;
            } catch (error) {
                console.error("Error getting video time:", error)
            }
        } else {
            // For web environment, you might want to implement a different way to get video time
            console.warn("Video time tracking not implemented for web environment")
        }
        return 0;
    }

    /**
     * 获取截图
     */
    const onGetVideoThumb = async ()=>{
        try {
            const snapShotUrl = await (sendBox.current as WebviewTag)?.executeJavaScript(`
      window.getSnapShot();
    `)
            return snapShotUrl
        } catch (error) {
            message.error(error);
        }
    }

    /**
     * 暂停播放.
     */
    const onPauseVideo = ()=>{
        (sendBox.current as WebviewTag).executeJavaScript(
            "window.onPause();",
        )
    }



    const getBilibiliEmbedUrl = (url: string) => {
        const bvMatch = url.match(/\/video\/(BV\w+)/)
        if (bvMatch && bvMatch[1]) {
            return bvMatch[1]
        }
        return null
    }

    const getLink = (time?: number,isAutoplay:any): string => {
        if (isBilibiliUrl(props.url)){
            const bid = getBilibiliEmbedUrl(props.url);
            const p = getUrlQueryParam(props.url,'p');
            getBilibiliVideoInfo(bid).then(res=>{
                mBilibiliInfo.current = res;
            })
            // return `https://www.bilibili.com/blackboard/html5player.html?bvid=${bid}&high_quality=1&as_wide=1&muted=0&autoplay=0&${time ? `&t=${time}` : ""}${p?`&p=${p}`:''}`
            const embed:any =  getEmbedLink(toValidURL(props.url),time);
            return embed?.link;
        }else if (isYoutubeUrl(props.url)){
            const embed:any =  getEmbedLink(toValidURL(props.url));

            return embed.link + (isAutoplay?'&autoplay=1&mute=1':'');
        }
        return props.url;
    }


    const generateIframe = (time?: number,isAutoplay:any) => {
        if (!iframeBoxRef.current) return;

        const iframe = document.createElement(isElectron ? "webview" : "iframe") as
            | HTMLIFrameElement
            | WebviewTag
        iframe.src = getLink(time,isAutoplay)

        if (isElectron) {
            // Electron webview specific attributes
            iframe.preload = `file://${Global.g_appPath}webview_preload.js`
            // iframe.setAttribute("disablewebsecurity", "1")
            // iframe.setAttribute("allowpopups", "")
            iframe.setAttribute('allow','accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture;autoplay; fullscreen');
            iframe.setAttribute("webpreferences", "contextIsolation=false,autoplayPolicy=document-user-activation-required,autoplay=yes")
            iframe.setAttribute(
                "sandbox",
                "allow-same-origin allow-scripts allow-forms allow-popups allow-popups-to-escape-sandbox allow-presentation allow-downloads",
            )

            iframe.addEventListener("new-window", (e) => {
                e.preventDefault()
            })

            iframe.addEventListener("dom-ready", async () => {
                // await (iframe as WebviewTag).executeJavaScript(`
                //   const video = document.querySelector('video');
                //   if (video) {
                //     video.currentTime = ${mSeekTime.current}
                //   }
                // `);

                iframe.setAttribute('autoplay', 'true')
                iframe.setAttribute('playsinline', 'true')

                await (iframe as WebviewTag).executeJavaScript(`
                const video = document.querySelector("video")
                if (video) {
                  video.currentTime = ${mSeekTime.current};
                }
                  ${scripts}
                  const new_style_element = document.createElement("style");
                  new_style_element.textContent = \`${styles}\`;
                  window.document.head.appendChild(new_style_element);
                `)


                if (props.iframeLoad){
                    props.iframeLoad();
                }
            })
        } else {
            // Regular iframe attributes
            iframe.setAttribute("scrolling", "no")
            iframe.setAttribute("border", "0")
            iframe.setAttribute("frameborder", "no")
            iframe.setAttribute("framespacing", "0")
            iframe.setAttribute("allowfullscreen", "true")
        }

        iframe.style.width = "100%"
        iframe.style.height = "100%"

        if (iframeBoxRef.current.children.length) {
            const child = iframeBoxRef.current.children[0]
            iframeBoxRef.current.removeChild(child)
        }

        sendBox.current = (iframe)
        iframeBoxRef.current.appendChild(iframe)
    }

    const formatTime = (seconds: number): string => {
        const hours = Math.floor(seconds / 3600)
        const minutes = Math.floor((seconds % 3600) / 60)
        const remainingSeconds = Math.floor(seconds % 60)
        return `${hours}:${minutes.toString().padStart(2, "0")}:${remainingSeconds.toString().padStart(2, "0")}`
    }

    const reloadIframe = (time: number = 0,hasReload=false) => {
        mSeekTime.current = time;
        // localStorage.setItem('seekTime',time);
        // alert('seektime')
        if (isWeb()){
            generateIframe(mSeekTime.current,props.isAutoPlay)
        }else{
            if (sendBox.current && iframeBoxRef.current) {
                const webViewTag =  (sendBox.current as WebviewTag);
                if(webViewTag){
                    try{
                        if(isYoutubeUrl(props.url) || isBaiduVideoUrl(props.url)){
                            (webViewTag).executeJavaScript(
                                `window.setCurrentVideoTime(${time})`,
                            );
                        }else{
                            (webViewTag).executeJavaScript(
                                `window.player.seek(${time})`,
                            );
                        }
                    }catch(e){

                    }
                }
            }
            if (hasReload && isBilibiliUrl(props.url)){
                generateIframe(mSeekTime.current,props.isAutoPlay)
            }
        }

    }


    return (
        <div style={{width: '100%', height: '100%',pointerEvents:props.pointerEvents || 'all'}}>
            <div ref={iframeBoxRef} className="w-full flex-1" style={{width: '100%', height: '100%'}}/>
        </div>
    )
})

export default VideoOtherContent;